import { render, staticRenderFns } from "./PointSeting.vue?vue&type=template&id=5b99e464&scoped=true&"
import script from "./PointSeting.vue?vue&type=script&lang=js&"
export * from "./PointSeting.vue?vue&type=script&lang=js&"
import style0 from "./PointSeting.vue?vue&type=style&index=0&id=5b99e464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b99e464",
  null
  
)

export default component.exports